


import { createAsyncThunk } from "@reduxjs/toolkit";
import { MarathonsAPI } from "api/api/marathonsApi/marathonsApi";
import {
  GetMyMarathonParticipantImagesParams,
  GetMyMarathonParticipantImagesRes,
} from "api/api/marathonsApi/types";
import axios from "axios";
import { List } from "entities/admin/model/slice/types";

export const getMyMarathonParticipantImages = createAsyncThunk<
  List<GetMyMarathonParticipantImagesRes>,
  GetMyMarathonParticipantImagesParams
>("marathons/getMyMarathonParticipantImages", async (params, { rejectWithValue }) => {
  try {
    const data = await MarathonsAPI.getMyMarathonParticipantImages(params);
    return data;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      console.error("Error while getting my participant images", error?.response?.data);
      return rejectWithValue(error?.response?.data || "Unknown error");
    } else {
      console.error("Error while getting my participant images", error);
      return rejectWithValue(
        "Что-то пошло не так... Попробуйте обновить страницу"
      );
    }
  }
});